<template>
    <div class="carCheck-expand-table">
      <el-table
        :data="tableData"
        style="width: 1620px;margin-bottom: 20px;"
        row-key="_detailNo"
        border
        default-expand-all>
        <el-table-column
          prop="picTypeName"
          label="名称"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="uploadTime"
          label="提交时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="picUrl"
          label="附件"
          width="100"
        >
          <template slot-scope="scope">
            <div v-if='scope.row.showPhotos' style="line-height: 0px;">
                <img src="@/assets/photos.png" @click.stop='$emit("btnEvent", "photos", scope.row)' @dblclick.stop="" style="width: 20px; cursor: pointer;">
            </div>
            <div v-else-if="scope.row.noShowPhotos"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="aiResultName"
          label="AI分析结果"
          width="180">
        </el-table-column>
        <el-table-column
          prop="aiDescription"
          label="异常原因"
          width="220"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="__approveStatusName__"
          label="审批状态"
          width="110">
        </el-table-column>
        <el-table-column prop="__approverName__"
          label="实际审批人"
          width="180"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="approveTime"
          label="审批时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="__approveReasonName__"
          label="审批备注"
          min-width="160"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template #default="scope">
            <!-- <el-button v-if="scope.row.__showAgreeBtn__" type="text" @click="handleAgreeBtn(scope.row)" size="small">同意</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    </template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'ExpandTableContent',
    props: {
        contentTableData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            tableData: []
        };
    },
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
        // 数据加工处理
        processData(row) {
            const data = JSON.parse(JSON.stringify(row));
            data.inspectionPicList.sort((a, b) => a.uploadTime - b.uploadTime);
            const map = new Map();
            data.inspectionPicList.forEach((item) => {
                const key = item.picType;
                // 多张照片合并在同一类型下
                if (!map.has(key)) {
                    map.set(key, item);
                } else {
                    // 优先取需要审批的最新时间的，如无需要审批的则取时间最新的
                    const oldValue = map.get(key);
                    if (!oldValue.attachmentId) {
                        if (item.attachmentId) {
                            map.set(key, item);
                        } else if (item.uploadTime > oldValue.uploadTime) {
                            map.set(key, item);
                        }
                    } else if (item.attachmentId) {
                        if (item.uploadTime > oldValue.uploadTime) {
                            map.set(key, item);
                        }
                    }
                }
                const listKey = `${key}List`;
                if (!data[listKey]) {
                    data[listKey] = [];
                }
                data[listKey].push({
                    uploadUserName: item.uploadUserName,
                    picUrl: item.picUrl,
                    uploadTime: item.uploadTime
                });
            });
            const result = Array.from(map.values());
            const dict = {
                status: this.dictData.CAR_CHECK_MANAGE_APPROVA_STATUS,
                aiResult: this.dictData.TMS_AI_RESULT,
                reason: this.dictData.TMS_INSPECTION_APPROVE_REASON
            };

            result.forEach((item, index) => {
                const listKey = `${item.picType}List`;
                item[listKey] = data[listKey];
                item._detailNo = index + 1;
                item.showPhotos = Boolean(item[listKey] && item[listKey].length);
                item.noShowPhotos = !item.showPhotos;
                item.aiResultName = item.aiResult ? dict.aiResult[item.aiResult] : '';
                // 字典编码转name
                const reasonName = dict.reason[_.toString(item.approveReason)];
                const approveStatus = _.toString(item.approveStatus);
                const approverCodeList = _.toString(item.approverCodeList).split(',').filter(Boolean);
                item.__approveStatusName__ = dict.status[approveStatus];
                item.__approveReasonName__ = reasonName ? `【${reasonName}】${item.remark || ''}` : '';
                // 判断显示同意按钮：待审批 且 当前登录MIP账号在审批人列表中, 如果审批列表为空则默认全部可操作
                if (approveStatus === '0') {
                    item.__showAgreeBtn__ = approverCodeList.length ? approverCodeList.includes(this.user.userCode) : true;
                } else {
                    item.__showAgreeBtn__ = false;
                }
                // 审批人
                if (item.approverName) {
                    item.__approverName__ = `${item.approverName}(${item.approverCode})`;
                } else {
                    item.__approverName__ = '';
                }
            });
            return result;
        },
        // 同意按钮
        handleAgreeBtn(attachRow) {
            const picList = this.contentTableData.inspectionPicList || [];
            const attachList = picList.filter(item => {
                if (!item.attachmentId) return false;
                return item.picType === attachRow.picType;
            }); // 根据类型反解出附件列表
            this.$emit('btnEvent', 'approve', attachList, this.contentTableData);
        }
    },
    created () {
        if (Array.isArray(this.contentTableData.inspectionPicList) && this.contentTableData.inspectionPicList.length > 0) {
            this.tableData = [];
            this.tableData = this.processData(this.contentTableData);
        }
    }
};
</script>
